export enum ProjectDocumentType {
  Project = 1,
  ChartDownload = 2,
  AuditPackage = 3,
  DataExport = 4,
  Intake = 5,
  InvoiceDownload= 6,
}
